import { render, staticRenderFns } from "./buildbyoneself.vue?vue&type=template&id=567dbb96&scoped=true&"
import script from "./buildbyoneself.vue?vue&type=script&lang=js&"
export * from "./buildbyoneself.vue?vue&type=script&lang=js&"
import style0 from "./buildbyoneself.vue?vue&type=style&index=0&id=567dbb96&lang=scss&scoped=true&"
import style1 from "./buildbyoneself.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567dbb96",
  null
  
)

export default component.exports